// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Components
import { Button } from "@components/Input";
// Assets
import { channelsSvg } from "assets";
import { arrowRightSvg } from "@assets";
// Vendor
import { showNotify } from "vendor/application/disptach";

class View extends Component {
  return = () => {
    const { history } = this.props;
    const { actualProject } = this.props.data;
    history.push(`/${actualProject.id}/integrations/directory`);
  };

  integrateChannel = (channel) => {
    const { limitsIntegrations } = this.props.data;
    const { history, location } = this.props;
    if (!limitsIntegrations[channel].in_plan) {
      this.props.dispatch(showNotify({ type: "link", severity: "info" }));
    } else if (!limitsIntegrations[channel].available) {
      this.props.dispatch(
        showNotify({ message: "channel_not_available", severity: "error" })
      );
    } else {
      history.push(`${location.pathname}/create`);
    }
  };

  render() {
    const { t } = this.props;
    return (
      <div className={"cen_integrations"}>
        <div className={"header"}>
          <div className={"header_content"}>
            <div onClick={() => this.return()} className={"header_action"}>
              {arrowRightSvg()}
            </div>
            <div className={"header_image"}>{channelsSvg("zendesk_full")}</div>
            <div className={"header_title"}>
              <span className={"title"}>
                {t("channels.zendesk_full.title")}
              </span>
              <span className={"description"}>{t("categories.business")}</span>
            </div>
          </div>
          <div className={"header_actions"}>
            <Button
              type={"primary"}
              onClick={() => {
                this.integrateChannel("zendesk_full");
              }}
              text={t("view.action_button")}
            />
          </div>
        </div>
        <div className={"content"}>
          <div className={"content_view"}>
            <span>{t("channels.zendesk_full.description")}</span>
            <span
              dangerouslySetInnerHTML={{
                __html: t("channels.zendesk_full.info").replaceAll(
                  "[br]",
                  "<br /><br />"
                )
              }}
            />
            <div className={"content_view_images"}>
              <img
                src={`${process.env.PUBLIC_URL}/img/views/integrations/zendesk_full/view_01.png`}
                alt=""
              />
              <img
                src={`${process.env.PUBLIC_URL}/img/views/integrations/zendesk_full/view_02.png`}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_view = connect(mapStateToProps)(View);

export default withTranslation("integrations")(withRouter(connect_view));
